<template>
  <div class="messagecenter">
    <div class="messagecenter-headline">
      <p class="headline-name">
        <!-- <a-icon type="sound" indeterminate="false" style="margin-right:10px" /> -->
        <img class="messageico" src="../../assets/imgs/xiaoxi.png" />
        <span @click="gomessagecenter">{{
          $t('translateText.MessageCenter.MessageParticulars.MessageCenter')
        }}</span>
        <a-icon type="right" style="margin:10px" />
        <span>{{
          $t(
            'translateText.MessageCenter.MessageParticulars.NotificationContent'
          )
        }}</span>
      </p>
    </div>
    <!-- {{ messageinfo }} -->
    <div class="messagecontent">
      <div class="message-headline">
        <div
          class="message-headline-list"
          :title="messageinfo.particulars.strMessageName"
        >
          {{ messageinfo.particulars.strMessageName }}
        </div>
        <div class="return" @click="messagefcenter">
          <img src="../../assets/imgs/fanhui.png" alt="" />
          <span>{{
            $t('translateText.MessageCenter.MessageParticulars.Return')
          }}</span>
        </div>
      </div>
      <div class="message-content">
        <p class="releaseobject-headline">
          <span>{{
            $t('translateText.MessageCenter.MessageParticulars.MessageContent')
          }}</span>
          <span> {{
            $t('translateText.MessageCenter.MessageParticulars.lzy')
          }} ：{{ messageinfo.user }}</span>
        </p>
        <!-- <input type="text" style="width:100%;height:90%;border:0;utline: none;"> -->
        <textarea
          class="textcenter"
          disabled
          v-model="messageinfo.particulars.strMessageContent"
        ></textarea>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { updateMessageState } from '../../utils/api'

export default {
  data() {
    return {
      // userinfo:{},
    }
  },
  methods: {
    messagefcenter() {
      this.$EventBus.$emit('messageinfo')
      this.$router.go(-1)
    },
    gomessagecenter() {
      this.$router.push('/newsCenter')
    },
  },
  computed: {
    ...mapState(['messageinfo', 'userinfo']),
  },
  created() {
    // var currentCity=localStorage.getItem("userinfo");
    // this.userinfo = this.$store.state.userinfo
    updateMessageState([
      {
        message: {
          iMessageId: this.messageinfo.id,
        },
        user: {
          iUserId: this.userinfo.iUserId,
        },
      },
    ]).then(() => {
      this.$EventBus.$emit('messageinfo')
    })
  },
}
</script>
<style lang="stylus" scoped>
.textcenter
    width:100%
    height:90%
    border:0
    outline: none
    resize: none
    padding:10px
    letter-spacing: 2px
    line-height: 24px
.messagecenter
    width 100%
    height 100%
    background-color white
.messagecenter-headline
    width 100%
    height 10%
    @media (max-width: 1025px)
        height 8%
    @media (max-width: 500px)
        height 15%
.messageico
    height 25%
    margin-right:10px
.headline-name
    width 90%
    height 90%
    margin-left 2%
    font-size 15px
    letter-spacing 2px
    font-weight: 700;
    display -webkit-flex
    display flex
    justify-content: flex-start
    align-items center
    border-bottom 2px solid #dadada
    & span
        cursor:pointer;
    @media (max-width: 1025px)
        font-size 20px
.messagecontent
    width 90%
    height 90%
.message-headline
    width 100%
    height 8%
    margin-left 2%
    .message-headline-list
        width 50%
        height 100%
        line-height 200%
        float left
        text-align left
        font-size 20px
        font-weight 700
        color #2FAEB6
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        // display flex
        // justify-content flex-start
        // align-items center
.return
    width 5%
    height 100%
    float right
    font-size 15px
    font-weight 700
    color  #959595
    display flex
    justify-content space-between
    align-items center
    cursor:pointer;
    @media (max-width: 1025px)
        width 8%
    & img
        height 30%
        @media (max-width: 1025px)
            height 20%
.releaseobject-headline
    width 100%
    height 10%
    background-color #F4F4F4
    font-size 15px
    display flex
    padding 0 2%
    justify-content space-between
    align-items center
    & span
        color #2FAEB6
.message-content
    width: 100%;
    height: 80%;
    float: left;
    border 1px #dadada solid
    margin-top: 1%;
    margin-left: 2%;
    float: left;
</style>
